import { useEffect, useMemo } from 'react';
import { changeStatusToKey, isCashinEnabledByChannelStatusKey$$ } from './cashin-utils';
import { isProfileCashinChannelStatusEnabled } from '../../../profiles';
import { useReframe } from 'nike-re-framejs';
import { resetPushPaths, startCashinChannelStatusPush } from './useIsCashinDisabled';
import { useComponentId } from '../../../common/hooks/useComponentId';

let subscribedChannelStatusKeys = new Map<number, string[]>();

const mapChanellStatus = cashinOffer => {
    if (!cashinOffer) return [];
    return cashinOffer?.picks.map(a => a.channelStatusId);
};

export const useIsChannelStatusDelayed = (cashinOffer: any): boolean => {
    const componentId = useComponentId();
    const channelStatusKeys: string[] = useMemo(
        () =>
            mapChanellStatus(cashinOffer)
                .map(changeStatusToKey)
                .sort(),
        [cashinOffer]
    );
    useEffect(() => {
        if (!channelStatusKeys?.length || !isProfileCashinChannelStatusEnabled()) {
            return () => {};
        }
        subscribedChannelStatusKeys.set(componentId, channelStatusKeys);
        startCashinChannelStatusPush();
        resetPushPaths();
        return () => {
            subscribedChannelStatusKeys.delete(componentId);
            resetPushPaths();
        };
    }, [componentId, channelStatusKeys]);
    const { subscribe } = useReframe();
    const isChannelStatusEnabled =
        subscribe(isCashinEnabledByChannelStatusKey$$(channelStatusKeys)) || !isProfileCashinChannelStatusEnabled();
    return !isChannelStatusEnabled;
};
